import { SvgIcon, SvgIconProps } from '@mui/material'

const HalfUserIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon role="img" viewBox="0 0 38 47" fill="none" {...props}>
      <path
        d="M10.0389 14.3049C10.8591 15.9521 12.1224 17.338 13.6868 18.3067C15.2513 19.2754 17.0549 19.7886 18.8949 19.7886C20.735 19.7886 22.5386 19.2754 24.1031 18.3067C25.6675 17.338 26.9308 15.9521 27.7509 14.3049C28.1226 13.5622 28.3981 12.7753 28.5709 11.9629C28.9044 10.4162 28.8623 8.812 28.448 7.28487C28.0338 5.75775 27.2596 4.35215 26.1902 3.18589C25.1208 2.01963 23.7875 1.12668 22.3019 0.581882C20.8164 0.0370799 19.2219 -0.143702 17.652 0.0546858C16.0822 0.253074 14.5828 0.824853 13.2795 1.7221C11.9762 2.61935 10.9069 3.81593 10.1613 5.21156C9.41569 6.60719 9.01547 8.16121 8.99418 9.74337C8.97289 11.3255 9.33116 12.8898 10.0389 14.3049Z"
        fill="white"
      ></path>
      <path
        d="M24.222 21.3584H13.569C11.853 21.3579 10.1538 21.6954 8.56824 22.3517C6.98273 23.008 5.54202 23.9701 4.32842 25.1833C3.11481 26.3964 2.15207 27.8368 1.49518 29.422C0.838297 31.0073 0.500131 32.7064 0.5 34.4224V43.4884C6.36112 45.7782 12.6079 46.9196 18.9 46.8504C25.1894 46.919 31.4332 45.7769 37.291 43.4864V34.4224C37.2911 32.7064 36.9531 31.0071 36.2964 29.4217C35.6396 27.8363 34.6768 26.3959 33.4632 25.1827C32.2495 23.9695 30.8087 23.0073 29.2231 22.3511C27.6374 21.6949 25.938 21.3576 24.222 21.3584Z"
        fill="white"
      ></path>
    </SvgIcon>
  )
}

export default HalfUserIcon
